/* Model */
class LocationOverrideTimeWindowModel extends App.Models.BaseModel {
  modelUrl = 'LocationOverrideTimeWindow';

  fetchWithCriteria = (obj) => {
    return Monet.Model.fetchWithCriteria({
      options: obj,
      model: this
    });
  }
}

App.Models.LocationOverrideTimeWindow = LocationOverrideTimeWindowModel;

/* Collection */
class LocationOverrideTimeWindowCollection extends App.Collections.BaseCollection {
  url = 'LocationOverrideTimeWindow';
  model = App.Models.LocationOverrideTimeWindow;
}

App.Collections.LocationOverrideTimeWindows = LocationOverrideTimeWindowCollection;

/* Router */
class LocationOverrideTimeWindowRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'LocationOverrideTimeWindow';
      const model = App.Models.LocationOverrideTimeWindow;
      const collectionClass = App.Collections.LocationOverrideTimeWindows;

      super(entityName, model, collectionClass);

      Monet.TabControl.closeActions.LocationOverrideTimenameWindow = () => {
        App.Objects.LocationOverrideTimeWindow.locationId = null;
      };
  }

  setParentId = (parentId) => {
    this.parentId = parentId;
    App.Objects.LocationOverrideTimeWindow.locationId = parentId;
  }

  getUrlBase = () => (
    `#/Location/${App.Objects.LocationOverrideTimeWindow.locationId}/LocationOverrideTimeWindow`
  );

  beforeCreateForm = () => {
    App.Objects.LocationOverrideTimeWindow.locationId =
      this.parentId || App.Objects.LocationOverrideTimeWindow.locationId;
  };

  afterCreateForm = () => {
    App.Objects.LocationOverrideTimeWindow.locationId =
      this.parentId || App.Objects.LocationOverrideTimeWindow.locationId;

    $("#LocationOverrideTimeWindow [name='btn_cancel']")
      .off()
      .on('click', () => (
        window.location = App.Objects.LocationOverrideTimeWindow.getUrlBase()
      ));
  };

  beforeCreate = (model_to_create) => {
    model_to_create.attributes.location = { id: App.Objects.LocationOverrideTimeWindow.locationId };
  };

  beforeUpdate = (updateModel) => {
    const location = { id: App.Objects.LocationOverrideTimeWindow.locationId };

    if (updateModel.attributes) {
      updateModel.attributes.location = location;
    } else {
      updateModel.location = location;
    }
  };

  afterCreate = () => {
    window.location = App.Objects.LocationOverrideTimeWindow.getUrlBase();
  };

  afterDestroy = () => {
    window.location = App.Objects.LocationOverrideTimeWindow.getUrlBase();
  };

  beforeList = () => {
    App.Forms.LocationOverrideTimeWindow.dataMapper.location.id = App.Objects.LocationOverrideTimeWindow.parentId;
    App.Objects.LocationOverrideTimeWindow.locationId = App.Objects.LocationOverrideTimeWindow.parentId || App.Objects.LocationOverrideTimeWindow.locationId;
    const filterBuilder = App.Forms.LocationOverrideTimeWindow.filterBuilder;
    this.addListeners();
    filterBuilder.setWillLoadState(false);
    filterBuilder.getCriteriaChain = () => ({
      criteriaChain: [{ and: [{ attr: 'location.id', eq: App.Objects.LocationOverrideTimeWindow.locationId }] }]
    });
  };

  addListeners = () => {
    $("#LocationOverrideTimeWindow [name='btn_novo']")
      .off()
      .on('click', () => (
        window.location = `${App.Objects.LocationOverrideTimeWindow.getUrlBase()}/new`
      ));
  };

  onValidate = () => {
    const validate = new Greenmile.TimeWindow.GeneralFunctions();
    this.allow_submit = validate.validateTimeWindow(this.allow_submit, 'LocationOverrideTimeWindow');
  };
}
App.Routers.LocationOverrideTimeWindow = LocationOverrideTimeWindowRouter;
